export default "__VITE_ASSET__DTCpU2Nf__"